export default "__VITE_ASSET__2c1f8791__"